export enum CommunityArticleImageType {
    IA = 0,
    DEPENDENCY = 1,
    NONE = 2,
    WEBSITE = 3,
    PRODUCT_PLACEMENT = 4
}